import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import BackToPreviousPageButton from '../../../components/Button/BackToPreviousPageButton';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import useDriverDetails from '../../../hooks/dashboard/driver-list/useDriverDetails';
import { DRIVER_LIST } from '../../../routes/routeConstants';
// import DistributionInsight from './DistributionInsight';
import DriverBioArea from './DriverBioArea';
// import DriverPerformanceData from './DriverPerformanceData';
import IncidentDistribution from './IncidentDistribution';
import DrivePerformanceChart from './LineChart/DrivePerformanceChart';
import MangeDriverDropDown from './MangeDriverDropDown';
import StatsCard from './StatsCard';

const DriverPerformanceExitReport = () => {
  const { ninNumber, driverId, name } = useParams();
  const { pathname } = useLocation();
  const { getDriverDetails, driverDetailsData } = useDriverDetails();
  const [refreshData, setRefreshData] = useState(0);

  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver List`,
        link: `/${DRIVER_LIST}`,
      },
      {
        name: `Results for: ${name}`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDriverDetails(driverId ?? '');
    // eslint-disable-next-line
  }, [driverId]);

  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <BackToPreviousPageButton
          path={DRIVER_LIST}
          compFn={() => (
            <MangeDriverDropDown
              data={{ driverId, name, ninNumber, ...driverDetailsData }}
              driverDetailsData={driverDetailsData}
              setRefreshData={setRefreshData}
            />
          )}
        />
        <Container>
          <HeaderArea>
            <DriverBioArea data={driverDetailsData} />
          </HeaderArea>
          <BoldText>Performance Index</BoldText>
          <StatsCard data={driverDetailsData} />
          <DrivePerformanceChart />
          <IncidentDistribution key={refreshData} />
          {/* <DistributionInsight />
          <DriverPerformanceData /> */}
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverPerformanceExitReport;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* background-color: red; */
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* padding-bottom: 28px; */
  /* border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor}; */
`;

const BoldText = styled.div`
  font-weight: 700;
  font-size: 18px;
`;
